import ReactPixel from '@mixtiles/react-facebook-pixel'
import { PRODUCT_TYPES, productTypeState } from '../../ProductTypeState'
import { toMetaPhone } from '../../User/phoneNumberNormalization'
import { logger } from 'services/logger'

function getPixelIdByProductType() {
  const productType = productTypeState.getProductType()
  switch (productType) {
    case PRODUCT_TYPES.CLASSIC:
      return window.KEYS.facebookPixelId
    case PRODUCT_TYPES.GIFT_CARD:
      return window.KEYS.facebookPixelId
    case PRODUCT_TYPES.BUSINESS:
      return window.KEYS.facebookPixelId
    case PRODUCT_TYPES.PHOTO_BOOK:
      return window.KEYS.facebookPixelId
    default:
      logger.error(
        `unknown product type when trying to get pixel id: ${productType}`,
        null,
        { productType }
      )
  }
}

const FACEBOOK_PIXEL_OPTIONS = {
  autoConfig: true, // set pixel's autoConfig
  debug: false, // enable logs
}

let isInitialized = false
let latestAdvancedMatching = {}

function initPixel() {
  ReactPixel.init(
    getPixelIdByProductType(),
    latestAdvancedMatching,
    FACEBOOK_PIXEL_OPTIONS
  )
  isInitialized = true
}

export function initFacebook(externalId, email) {
  if (isInitialized) return

  const initialMatching = {}
  if (externalId) initialMatching.external_id = externalId
  if (email) initialMatching.em = email
  latestAdvancedMatching = { ...latestAdvancedMatching, ...initialMatching }

  initPixel()
}

export function updateFacebookAdvancedMatching({ email, phoneNumber }) {
  const metaPhoneNumber = phoneNumber ? toMetaPhone(phoneNumber) : undefined
  const emailChanged = email && email !== latestAdvancedMatching.em
  const phoneChanged =
    metaPhoneNumber && metaPhoneNumber !== latestAdvancedMatching.ph
  if (!emailChanged && !phoneChanged) return

  if (emailChanged) latestAdvancedMatching.em = email
  if (phoneChanged) latestAdvancedMatching.ph = metaPhoneNumber
  if (isInitialized) {
    initPixel()
  }
}

export { ReactPixel as Pixel }
